import React from 'react';
import { EaseModal } from '../../../../../libs/EaseModal';
import { Text1 } from '../../../../../styles';
import { VendorForm } from '../../Forms/Vendor';

const VendorModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {`${props.vendor.is_edit ? "Edit" : "Add"} Vendor`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={500}
            title={false}
            visible={props.visible}
            onCancel={props.toggleVendorModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <VendorForm
                vendor={props.vendor}
                onVendorSave={props.onVendorSave}
            />
        </EaseModal>
    )
};

VendorModal.defaultProps = {
    vendor: {}
};

export { VendorModal };